import { useIntl } from 'react-intl'

import './PrivacyTag.css'

interface PrivacyTagProps {
  privacy: 'public' | 'private'
}

export default function PrivacyTag({ privacy }: PrivacyTagProps) {
  const intl = useIntl()
  const privacyText = intl.formatMessage({ id: `privacy.${privacy}` })
  return (
    <div title={privacyText} className={`privacy-tag ${privacy}`}>
      <span
        className={`icon status-icon ${privacy === 'public' ? 'icon-global' : 'icon-lock-closed'}`}
      />
      <span className="privacy-text">
        {intl.formatMessage({ id: `privacy.${privacy}` })}
      </span>
    </div>
  )
}
